import React, { useEffect, useState } from 'react';
import axios from 'axios';
import {
  Route, Switch, useLocation, useHistory,
} from 'react-router-dom';
import { Statistic } from '@b3w/react-statistic';
import Header from 'components/Header/Header';
import Footer from 'components/Footer/Footer';
import AddToHomeScreen from 'components/AddToHomeScreen/AddToHomeScreen';
import PPPortal from 'components/PPPortal/PPPortal';
import CategoryItemPage from 'pages/CategoryItemPage/CategoryItemPage';
import MainPage from 'pages/MainPage/MainPage';
import Page404 from 'pages/Page404/Page404';
import getCodeStatus from 'helpers/getCodeStatus';
import useFirebase from 'hooks/useFirebase';
import Text from 'pages/Text/Text';
import Api, { SERVICE_ALIAS, BASE_PATH } from 'constants/constants';

const App = () => {
  const location = useLocation();
  const history = useHistory();
  const [ppText, setPpText] = useState('');
  useEffect(() => {
    window.scroll(0, 0);
  }, [location.pathname]);

  const codeStatus = getCodeStatus(location.search);
  useFirebase();

  useEffect(() => {
    if (codeStatus === '7') {
      history.push(location.pathname);
    }
  }, [codeStatus]);

  useEffect(() => {
    axios.get(`${BASE_PATH}/text/${SERVICE_ALIAS}/privacyfooter/1`)
      .then((res) => {
        if (res.data) setPpText(res.data);
      })
      .catch(() => {});
  }, []);

  return (
    <>
      <Statistic
        path={`${BASE_PATH}/referer/statistic`}
        from
        timeoutMinutes={1}
      />
      <PPPortal text={ppText} />
      <Header />
      <Switch>
        <Route path="/user/conditions/">
          <Text path={Api.OFFER} />
        </Route>
        <Route path="/privacypolicy">
          <Text path={Api.PPOLICY} />
        </Route>
        <Route path="/:alias/:id" component={CategoryItemPage} />
        <Route path="/:alias" component={MainPage} />
        <Route exact path="/" component={MainPage} />
        <Route component={Page404} />
      </Switch>
      <Footer />
      <AddToHomeScreen />
    </>
  );
};

export default App;
